// Lugares da tela de procurar mesa na liga, a partir da fila em números que a mesa manda.
import type { TrioNaBusca } from '@truco6/mesa/protocolo';

export interface LugarDaBusca {
  r: number; // 0 é você; de 1 a 5, os lugares em volta na ordem da mesa
  nos: boolean;
  tipo: 'voce' | 'parceiro' | 'encontrado' | 'procurando';
  parceiro?: TrioNaBusca['parceiros'][number];
}

// Os 5 lugares em volta se preenchem na ordem da mesa com min(naFaixa, 5). Com trio fixo, os 2 parceiros
// ocupam os lugares de NÓS desde o início e contam dentro do naFaixa.
export function lugaresDaBusca(naFaixa: number, parceiros: TrioNaBusca['parceiros'] = []): LugarDaBusca[] {
  const lugares: LugarDaBusca[] = Array.from({ length: 6 }, (_, r) => ({ r, nos: r % 2 === 0, tipo: r === 0 ? 'voce' : 'procurando' }));
  [2, 4].forEach((r, i) => { const p = parceiros[i]; if (p) lugares[r] = { r, nos: true, tipo: 'parceiro', parceiro: p }; });
  let faltam = Math.max(0, Math.min(5, naFaixa) - parceiros.length);
  for (const l of lugares) if (faltam > 0 && l.tipo === 'procurando') { l.tipo = 'encontrado'; faltam--; }
  return lugares;
}

export function textoDaFila(total: number): string {
  return total <= 1 ? 'Só você procurando mesa agora' : `${total} pessoas procurando mesa agora`;
}

// Para o leitor de tela: "3 jogadores encontrados. Faltam 2."
export function falaDosLugares(lugares: LugarDaBusca[]): string {
  const n = lugares.filter((l) => l.tipo === 'parceiro' || l.tipo === 'encontrado').length, faltam = 5 - n;
  const achados = n === 0 ? 'Nenhum jogador encontrado ainda.' : n === 1 ? '1 jogador encontrado.' : `${n} jogadores encontrados.`;
  return `${achados} ${faltam === 0 ? 'Mesa completa.' : faltam === 1 ? 'Falta 1.' : `Faltam ${faltam}.`}`;
}
